import React from "react"
import { FiAlertTriangle, FiXCircle } from "react-icons/fi"

import {
  Button,
  Dialog,
  DialogMessage,
  Overlay,
  CloseButton,
  Content,
} from "./style"

interface ConfirmationDialogProps {
  open: boolean
  message: string
  onClose?: () => void
}

const Alert: React.FC<ConfirmationDialogProps> = ({
  open,
  message,
  onClose,
}) => {
  return (
    <Overlay open={open}>
      <Dialog>
        <CloseButton onClick={onClose}>
          <FiXCircle />
        </CloseButton>

        <Content>
          <div>
            <FiAlertTriangle />
          </div>

          <div>
            <h1>Atenção</h1>
            <DialogMessage>{message}</DialogMessage>

            <Button onClick={onClose}>Entendido</Button>
          </div>
        </Content>
      </Dialog>
    </Overlay>
  )
}

export default Alert
